import { Container, Paragraph } from 'component-library';
import {
  type SelectedUser as SelUser,
  type SelectedHierarchyInfo as SelHierarchy,
} from '../../types';
import SelectedHierarchy from './SelectedHierarchy';

type SelectedUserProps = {
  user: SelUser | undefined;
  hierarchy: SelHierarchy | undefined;
};

const SelectedUser: React.FC<SelectedUserProps> = ({ user, hierarchy }: SelectedUserProps) =>
  user ? (
    <Container outline={true}>
      <div style={{ display: 'flex', gap: '24px' }}>
        <div style={{ width: '50%' }}>
          <Paragraph variant="large">{user.fullName}</Paragraph>
          <Paragraph variant="large">{user.email}</Paragraph>
          <Paragraph variant="large">{user.phone}</Paragraph>
        </div>
        <SelectedHierarchy hierarchy={hierarchy} />
      </div>
    </Container>
  ) : null;

export default SelectedUser;
